import { api } from "api/apiHelper";
import { Endpoints } from "api/apiConst";

export const getPlatformStats = async (params?: object) => {
  const endpoint = Endpoints.PLATFORM + "/statistics";
  return api
    .get(endpoint, {
      params: { ...params },
    })
    .then((response) => response.data);
};
